// extracted by mini-css-extract-plugin
module.exports = {"table":"LoanProfileDocuments_table__3LVzd","actions":"LoanProfileDocuments_actions__1nNmY","docName":"LoanProfileDocuments_docName__1nrJp"};